
import theme from '@travelnest/merlin.theme';
import React, { useState } from 'react';
import { IPromotionOpportunity } from '../../../data/entities/promotions';
import { Paragraph } from '../paragraph/Paragraph';

export const PromotionItem: React.FC<{
	promotion: IPromotionOpportunity;
	onSelectPromotion: (promotion: IPromotionOpportunity) => void;
}> = ({ promotion, onSelectPromotion }) => {
	const [checked, setChecked] = useState(false);
	const { display_name, description } = promotion;
	return (
		<div className="promotions-item" style={{ display: 'flex', flexDirection: 'column' }} key={promotion.internal_reference}>
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<div style={{ height: '30px' }}>
					<h3>{display_name}</h3>
				</div>
				<div>
					<input
						style={{
							width: '40px',
							height: '40px',
							borderLeft: `1px solid ${theme.colours.neutral.light}`,
						}}
						data-testid={`test-checkbox-${display_name}`}
						name={display_name}
						type="checkbox"
						onChange={() => {
							setChecked(!checked);
							onSelectPromotion(promotion);
						}}
						checked={checked}
					/>
				</div>
			</div>
			<div>
				<Paragraph>{description}</Paragraph>
			</div>
		</div>
	);
};
